import api from './axios';
import type { BrandingConfig } from '../types/user.types';

export async function getBranding(): Promise<BrandingConfig> {
  const { data } = await api.get<{ data: BrandingConfig }>('/api/v2/branding');
  return data.data;
}

export async function updateBranding(body: Partial<BrandingConfig>): Promise<BrandingConfig> {
  const { data } = await api.patch<{ data: BrandingConfig }>('/api/v2/branding', body);
  return data.data;
}
